import { Component, OnDestroy } from '@angular/core';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { Subscription } from 'rxjs';
import { CreateColumn, CreateDefaultBasicColumn, CreateNonTypedColumn, TableColumn } from 'src/app/models/tableColumn';
import { RequestStatusService } from '../requeststatus.service';
import { DataTypeEnum } from 'src/app/constants/data-type.enum';
import { DocumentForOverviewModel } from 'src/app/models/api/document-for-overview.model';

@Component({
  selector: 'app-request-status-documents-list',
  templateUrl: './requeststatusdocumentslist.component.html'
})
export class RequeststatusdocumentslistComponent implements OnDestroy {

  documentList!: DocumentForOverviewModel[];
  requestGuid!: string;
  documentCount: number = 0;
  private requestSubscription!: Subscription;

  columnsToDisplay: TableColumn[] = [
    CreateColumn<DocumentForOverviewModel>('name', 'Name', DataTypeEnum.General, 5, true),
    CreateColumn<DocumentForOverviewModel>("documentType", 'DocumentType', DataTypeEnum.DocumentType, 2, true),
    CreateColumn<DocumentForOverviewModel>("size", 'FileSize', DataTypeEnum.FileSize, 2, true),
    CreateColumn<DocumentForOverviewModel>("identifier", 'Id', DataTypeEnum.Guid, 2, true),
  ];

  constructor(private requestStatusService: RequestStatusService, private documentService: DocumentApiClient) {
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      if (Object.keys(request).length === 0) {
        return;
      }
      if (this.requestGuid != request.id || this.documentCount != request.documentInfo.length) {
        this.requestGuid = request.id;
        this.documentCount = request.documentInfo.length;
        this.documentService.getForOverview(this.requestGuid).subscribe(documentModels => {
          this.documentList = documentModels;
        });
      }

      // check if actions can be added (rights issue) and make sure it is not added double
      let actionColumnToAddAndVerify: TableColumn = CreateNonTypedColumn('actions', '', DataTypeEnum.General, 1, false);
      if (this.requestStatusService.hasUserEditRights() && this.columnsToDisplay.findIndex(column => column.columnName === actionColumnToAddAndVerify.columnName) < 0) {
        this.columnsToDisplay.push(actionColumnToAddAndVerify);
      }

    });

  }

  ngOnDestroy(): void {
    this.requestSubscription.unsubscribe();
  }
}
